import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Company Offer Types',
  basePath: '/company-offer-types',
  reorderable: true,
  columns: [
    { key: 'title', label: 'Company Offer Type' },
  ],
  fields: [
    { key: 'title', label: 'Company offer type', type: 'text', required: true },
  ],
});
